import { Box, SingleSelect } from '@air/zephyr';
import { Formik } from 'formik';

import { Form } from '~/old-marketing/components/Form';
import { AgencyLocations } from '~/old-marketing/constants/AgencyLocations';
import { AgencySizes } from '~/old-marketing/constants/AgencySizes';
import { AgencyTypes } from '~/old-marketing/constants/AgencyTypes';

export type AgencyListFiltersValues = {
  location: string;
  service: string;
  size: string;
};

export interface AgencyListFiltersProps {
  onChange: (values: AgencyListFiltersValues) => void;
  values: AgencyListFiltersValues;
}

export const AgencyListFilters = ({ onChange, values }: AgencyListFiltersProps) => {
  return (
    <Box>
      <Formik
        initialValues={values}
        onSubmit={(values) =>
          onChange({
            location: values.location,
            service: values.service,
            size: values.size,
          })
        }
      >
        {({ submitForm }) => (
          <Form>
            <Box tx={{ display: 'flex', justifyContent: 'space-between', flexDirection: ['column', 'row'], mb: 56 }}>
              <SingleSelect
                escapeClearsValue
                label="Location"
                onMenuClose={() => submitForm()}
                options={[
                  { label: 'All locations', value: '' },
                  ...AgencyLocations.map((location) => ({ label: location.replace(',', ', '), value: location })),
                ]}
                name="location"
                required={false}
                tx={{ width: '100%', mb: [16, 0] }}
              />
              <SingleSelect
                escapeClearsValue
                label="Service"
                onMenuClose={() => submitForm()}
                options={[
                  { label: 'All services', value: '' },
                  ...AgencyTypes.map((type) => ({ label: type.name, value: type.value })),
                ]}
                name="service"
                required={false}
                tx={{ width: '100%', mx: [0, 16], mb: [16, 0] }}
              />
              <SingleSelect
                escapeClearsValue
                label="Size"
                onMenuClose={() => submitForm()}
                options={[
                  { label: 'All sizes', value: '' },
                  ...AgencySizes.map((size) => ({ label: size.name, value: size.value })),
                ]}
                name="size"
                required={false}
                tx={{ width: '100%', mb: [16, 0] }}
              />
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};
